import { cn } from "@/lib/utils";
import * as React from "react";

const SheetFooter: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
  className,
  ...props
}) => (
  <div className={cn("flex flex-col-reverse gap-2", className)} {...props} />
);

SheetFooter.displayName = "SheetFooter";

export default SheetFooter;
